import React from 'react';
import { Dots } from 'react-activity';
import 'react-activity/dist/Dots.css';
import { View } from '../../component';
// import Text from '../text';
import { isMobileBrowser } from '../../utilities/helper';
import Image from '../image';
import './index.css';

interface Props {
  visible: boolean;
  onDesktopLeftward?: boolean;
  loaderImage: any;
}

const IframeLoader = ({ visible, onDesktopLeftward = false, loaderImage = null }: Props) => {
  if (!visible) return null;

  const className = `iframe-loader-image ${isMobileBrowser ? 'iframe-loader-image-mobile' : ''}`;

  return (
    <View className={'iframe-loader-container'}>
      <View
        style={{
          width: onDesktopLeftward ? '550px' : '100%'
        }}
        className={'iframe-loader-wrapper'}>
        <Image source={loaderImage} className={className} />
        {/* <Text className={'iframe-loader-text'}>{'Loading...'}</Text> */}
        <Dots size={25} color={'white'} />
      </View>
    </View>
  );
};

export default React.memo(IframeLoader);
